import React from 'react';
import Image from 'next/image';
import { RobotMessageImageProps } from './chat-demo-type-defs';

const RobotMessageImage: React.FC<RobotMessageImageProps> = (
    props: RobotMessageImageProps,
) => {
    const { batchImages } = props;

    const normalImage = batchImages.find((image) => image.type == 'NORMAL');
    const maskImage = batchImages.find((image) => image.type == 'MASK');

    return (
        <div
            className="flex h-full w-full flex-col overflow-hidden rounded-[8px]"
            style={{ cursor: 'zoom-in' }}
        >
            {normalImage?.url && (
                <div
                    className={`relative min-h-0 w-full flex-1 overflow-hidden ${maskImage?.url ? 'rounded-t-[8px]' : 'rounded-[8px]'}`}
                >
                    <Image
                        className="robot-image"
                        alt={normalImage.desc ?? 'source-image'}
                        title={normalImage.name ?? 'source-image'}
                        fill
                        sizes="(max-width: 640px) 50vw, 25vw"
                        style={{
                            objectFit: 'cover',
                            objectPosition: 'center',
                            userSelect: 'none',
                        }}
                        src={normalImage.url}
                        unoptimized
                    />
                </div>
            )}

            {maskImage?.url && (
                <div className="relative min-h-0 w-full flex-1 overflow-hidden rounded-b-[8px]">
                    <Image
                        className="robot-image"
                        alt={maskImage.desc ?? 'mask-image'}
                        title={maskImage.name ?? 'mask-image'}
                        fill
                        sizes="(max-width: 640px) 50vw, 25vw"
                        style={{
                            objectFit: 'cover',
                            objectPosition: 'center',
                            userSelect: 'none',
                        }}
                        src={maskImage.url}
                        unoptimized
                    />
                </div>
            )}
        </div>
    );
};

export default React.memo(RobotMessageImage);
